export interface IMenu {
  title: string;
  link: string;
  logout?: boolean;
}

export const menuAboutUs: IMenu[] = [
  {
    title: '关于校友会',
    link: '/cn/about-us/nsaa',
  },
  {
    title: '校友会历史',
    link: '/cn/about-us/history',
  },
  {
    title: '校友会执委',
    link: '/cn/about-us/committee',
  },
];
export const menuContactUs: IMenu[] = [
  {
    title: '联络我们',
    link: '/cn/contact-us',
  },
  {
    title: '加入我们的邮件列表',
    link: '/cn/subcription-center',
  },
];
